import ar from './ar'
import bg from './bg'
import cs from './cs'
import da from './da'
import de from './de'
import el from './el'
import en from './en'
import es from './es'
import es_mx from './es-mx'
import et from './et'
import fa from './fa'
import fi from './fi'
import fr from './fr'
import fr_ca from './fr-ca'
import he from './he'
import hr from './hr'
import hu from './hu'
import id from './id'
import it from './it'
import ja from './ja'
import kk from './kk'
import ko from './ko'
import lt from './lt'
import lv from './lv'
import mk from './mk'
import ms from './ms'
import nl from './nl'
import pl from './pl'
import pt from './pt'
import pt_br from './pt-br'
import ro from './ro'
import ru from './ru'
import sk from './sk'
import sl from './sl'
import sr from './sr'
import sv from './sv'
import th from './th'
import tr from './tr'
import uk from './uk'
import ur from './ur'
import uz from './uz'
import vi from './vi'
import zh from './zh'
import zh_hk from './zh-hk'
import zh_tw from './zh-tw'

const locales = {
  ar,
  bg,
  cs,
  da,
  de,
  el,
  en,
  es_mx,
  es,
  et,
  fa,
  fi,
  fr_ca,
  fr,
  he,
  hr,
  hu,
  id,
  it,
  ja,
  kk,
  ko,
  lt,
  lv,
  mk,
  ms,
  nl,
  pl,
  pt_br,
  pt,
  ro,
  ru,
  sk,
  sl,
  sr,
  sv,
  th,
  tr,
  uk,
  ur,
  uz,
  vi,
  zh_hk,
  zh_tw,
  zh
}

export default locales
